import {
  CircularProgress,
  Container,
  Grid,
  TextField,
} from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import React, { useState } from 'react';
import CustomAlert from '../../components/alert/CustomAlert';
import BlueButton from '../../components/button/BlueButton';
import omniloraService from '../../Services/Omnilora/omnilora-service';

export default function FormularioOmniloraComponent({ NumeroSerie, idClienteShownet, NA, OS, IDTecnico, CampoPreenchido }) {
  const [idLora, setIDLora] = useState('');
  const [abrirAlert, setAbrirAlert] = useState(false);
  const [mensagemAlert, setMensagemAlert] = useState('');
  const [tipoAlert, setTipoAlert] = useState('error');
  const [isLoadingInicio, setIsLoadingInicio] = useState(false);
  const [errors, setErrors] = useState({});

  const showAlert = (title, body, type = 'error') => {
    setMensagemAlert({ title, body });
    setTipoAlert(type);
    setAbrirAlert(true);
  };

  const validateFormOmnilora = () => {
    const newErrors = {};

    if (!idLora) {
      newErrors.idLora = 'O id Lora é obrigatório.';
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const enviarOmnilora = async (event) => {
    event.preventDefault();

    if (!validateFormOmnilora()) {
      showAlert(
        'Atenção!',
        'Por favor, preencha todos os campos obrigatórios.',
        'fail'
      );
      return;
    }

    try {
      setIsLoadingInicio(true);
      const omniloraResultado = await omniloraService.buscarOmnilora(idLora);

      if (!omniloraResultado.error && omniloraResultado?.result?.qtdRetornos > 0) {
        const dadosAtualizar = {
          id: omniloraResultado.result.comandos[0].id,
          idCliente: idClienteShownet,
          serial: NumeroSerie,
          idLora: idLora,
          status: omniloraResultado.result.comandos[0].status == 'Ativo' ? 1 : 0,
          na: NA,
          os: OS,
          idTecnico: IDTecnico
        };

        const omniloraAtualizarResultado = await omniloraService.atualizarOmnilora(dadosAtualizar);

        if (omniloraAtualizarResultado.error) {
          if (
            typeof omniloraAtualizarResultado.message === 'string' &&
            omniloraAtualizarResultado.message === 'Serial já está cadastrado.'
          ) {
            CampoPreenchido();
            setIsLoadingInicio(false);
            return;
          }

          showAlert(
            'Atenção!',
            omniloraAtualizarResultado.message,
            'fail'
          );
        } else {
          showAlert(
            'Sucesso!',
            'Edição realizada com sucesso!',
            'success'
          );
          CampoPreenchido();
        }
      } else {
        const dadosCadastrar = {
          idCliente: idClienteShownet,
          serial: NumeroSerie,
          idLora: idLora,
          na: NA,
          os: OS,
          idTecnico: IDTecnico
        };

        const omniloraCadastrarResultado = await omniloraService.cadastrarOmnilora(dadosCadastrar);

        if (omniloraCadastrarResultado.error) {
          if (
            typeof omniloraCadastrarResultado.message === 'string' &&
            omniloraCadastrarResultado.message === 'Serial já está cadastrado.'
          ) {
            CampoPreenchido();
            setIsLoadingInicio(false);
            return;
          }

          showAlert(
            'Atenção!',
            omniloraCadastrarResultado.message,
            'fail'
          );
        } else {
          showAlert(
            'Sucesso!',
            'Cadastro realizado com sucesso!',
            'success'
          );
          CampoPreenchido();
        }
      }

      setIsLoadingInicio(false);

    } catch (error) {
      setIsLoadingInicio(false);
      showAlert(
        'Atenção!',
        'Ocorreu um erro inesperado. Tente novamente mais tarde.',
        'error'
      );
    }
  }

  return (
    <Container style={{ padding: '5px' }}>
      <CustomAlert
        open={abrirAlert}
        message={mensagemAlert}
        type={tipoAlert}
        onClose={() => setAbrirAlert(false)}
      />
      <Grid container spacing={3}>
        <Grid item xs={12} md={5} lg={3}>
          <TextField
            name="idLora"
            label={
              <span>
                ID Lora <span style={{ color: 'red' }}>*</span>
              </span>
            }
            variant="outlined"
            fullWidth
            value={idLora}
            onChange={(e) => setIDLora(e.target.value)}
            onInput={(e) => {
              const value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
              setIDLora(value);
            }}
            InputLabelProps={{
              shrink: true,
            }}
            error={!!errors.idLora}
            helperText={errors.idLora}
          />
        </Grid>
        <Grid item xs={12} md={5} lg={3}>
          <BlueButton
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            style={{ height: 55 }}
            onClick={enviarOmnilora}
            startIcon={
              isLoadingInicio ? <CircularProgress size={20} /> : <RefreshIcon />
            }
            disabled={isLoadingInicio}
          >
            <span style={{ fontSize: '0.7rem' }}>
              {isLoadingInicio ? ' Cadastrando...' : ' Cadastrar Omnilora'}
            </span>
          </BlueButton>
        </Grid>
      </Grid>
    </Container>
  );
}
